import {useDataProvider, useNotify, useQuery, useRefresh} from "react-admin";
import React from "react";
import {Form, InputNumber} from "antd";
import {createSubmitHandler} from "@src/components/Settings/utils";
import {ExtendedDataProvider} from "@src/types";


const ExternalAPISettingsForm = () => {
    const notify = useNotify();
    const [form] = Form.useForm ();
    const refresh = useRefresh();
    const dataProvider: ExtendedDataProvider = useDataProvider ()
    const settingsName = "ExternalAPISettings"
    const initRateLimit = 10;
    const initLimitResponsePerMinute = 5;

    const minRateLimit = 1;
    const maxRateLimit = 10;


    const {loaded, error, data: currentSettings} = useQuery ({
        type: 'getOne',
        resource: 'general_settings',
        payload: {id: settingsName}
    });

    return (
        <>
            {
                (loaded || error) &&
                <Form
                    form={form}
                    labelAlign='left'
                    colon={false}
                    labelCol={{ span: 10 }}
                    wrapperCol={{ span: 14 }}
                    onFinish={createSubmitHandler(settingsName, currentSettings, dataProvider, notify, refresh)}
                >
                    {/* The label names the field and nothing else. What each one
                        means goes under its control, where it has the width to
                        wrap: as part of the label it was squeezed into a third
                        of the panel, ran to four lines, and overflowed the fixed
                        row height onto the field below it. */}
                    <Form.Item
                        label="Webhook Rate Limit Per Minute"
                        extra={`Maximum number of webhook requests sent per minute. Enter a whole number between ${minRateLimit} and ${maxRateLimit}.`}
                        initialValue={currentSettings?.['config']?.webhook_rate_limit_per_minute || initLimitResponsePerMinute}
                        name="webhook_rate_limit_per_minute"
                    >
                        <InputNumber min={minRateLimit} max={maxRateLimit} precision={0} style={{ width: '100%' }} />
                    </Form.Item>

                    <Form.Item
                        label="Webhook Response Rate Limit"
                        extra={`Maximum number of webhook responses saved in NetOrca. Enter a whole number between ${minRateLimit} and ${maxRateLimit}.`}
                        initialValue={currentSettings?.['config']?.webhook_response_rate_limit || initRateLimit}
                        name="webhook_response_rate_limit"
                    >
                        <InputNumber min={minRateLimit} max={maxRateLimit} precision={0} style={{ width: '100%' }} />
                    </Form.Item>

                    <Form.Item
                        label="Healthcheck Rate Limit Per Minute"
                        extra={`Maximum number of healthcheck requests made per minute. Enter a whole number between ${minRateLimit} and ${maxRateLimit}.`}
                        initialValue={currentSettings?.['config']?.healthcheck_rate_limit_per_minute || initLimitResponsePerMinute}
                        name="healthcheck_rate_limit_per_minute"
                    >
                        <InputNumber min={minRateLimit} max={maxRateLimit} precision={0} style={{ width: '100%' }} />
                    </Form.Item>

                    <Form.Item
                        label="Healthcheck Response Rate Limit"
                        extra={`Maximum number of healthcheck responses saved in NetOrca. Enter a whole number between ${minRateLimit} and ${maxRateLimit}.`}
                        initialValue={currentSettings?.['config']?.healthcheck_response_rate_limit || initRateLimit}
                        name="healthcheck_response_rate_limit"
                    >
                        <InputNumber min={minRateLimit} max={maxRateLimit} precision={0} style={{ width: '100%' }} />
                    </Form.Item>

                </Form>
            }
        </>
    )
}

export default ExternalAPISettingsForm;
